import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { patientApi } from "../api/services/patientApi";
import { rtkQuerySentryMiddleware } from "./middleware/rtkQuerySentryMiddleware";

export const store = configureStore({
  reducer: {
    // generated reducers as specific top-level slices
    [patientApi.reducerPath]: patientApi.reducer,
  },
  //Adding the api middleware enables caching, invalidation, polling, and other useful features of 'rtk-query'
  middleware: (getDefaultMiddleWare) =>
    getDefaultMiddleWare().concat(
      patientApi.middleware,
      rtkQuerySentryMiddleware,
    ),
});
// this is optional, but is required for refetchOnFocus/refetchOnReconnect.
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
